export default __webpack_public_path__ + "static/media/3_3.4454c6c0.png";